import React, { useEffect, useState } from "react";
import HomepageSidebar from "./HomePageSidebar";
import { HomePagePosts } from "./HomePagePosts";
import { HomePageConnections } from "./HomePageConnections";
import axios from "axios";
import { redirect, useNavigate } from "react-router-dom";
import base_url from "../../Utils/server";
import { toast } from "react-toastify";
export function loader({req}){
  console.log(sessionStorage.getItem("jwtToken")==null)
  if(sessionStorage.getItem("jwtToken")==null){
    throw redirect("/?message=PleaseLogin")
  }
  return null;
}
export const HomePage = () => {
  const navigate=useNavigate();

  const [nonConnections, setNonConnections] = useState([]);
  
  const Token = sessionStorage.getItem("jwtToken");
  useEffect(() => {
    axios
      .get(`${base_url}/nonconnections`, {
        headers: {
          Authorization: `Bearer ${Token}`,
        },
      })
      .then((res) => {
        setNonConnections(res.data.data);
      })
      .catch((e)=>{
        toast.error("Error Fetching Non- connections")
      })
  }, []);
  return (
    <>
      <HomepageSidebar />
      <HomePagePosts nonConnections={nonConnections}/>
    <HomePageConnections nonConnections={nonConnections} setNonConnections={setNonConnections} Token={Token}/>
    </>
  );
};
